import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { SearchableAppInterface } from 'src/app/core/services/apps-search-service/searchable-app.interface';
import { SearchableCollectionInterface } from 'src/app/core/services/collections-search-service/searchable-collection.interface';
import {
  AppInterface,
  ClickOnAppBehavior,
  DisplayType,
} from '../../../../interfaces/app.interface';
import { ApplicationComponent } from '../../../app/application.component';
import { CollectionFinderItemComponent } from '../collection-finder-item/collection-finder-item.component';

@Component({
  selector: 'app-finder-result',
  imports: [ApplicationComponent, CollectionFinderItemComponent],
  templateUrl: './app-finder-result.component.html',
  styleUrls: ['./app-finder-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFinderResultComponent {
  apps = input.required<SearchableAppInterface[]>();
  collections = input.required<SearchableCollectionInterface[]>();

  appsAndCollectionsFinderSorted = computed(() => {
    const appsFinder = this.apps();
    const collectionsFinder = this.collections();

    const appsAndCollections: (SearchableAppInterface | SearchableCollectionInterface)[] = [
      ...appsFinder,
      ...collectionsFinder,
    ];

    return appsAndCollections.sort(this.sortByRelevance);
  });

  private sortByRelevance(
    a: SearchableAppInterface | SearchableCollectionInterface,
    b: SearchableAppInterface | SearchableCollectionInterface,
  ) {
    if (!a.searchPriorityConfig || !b.searchPriorityConfig) return 0;

    const aConfig = a.searchPriorityConfig;
    const bConfig = b.searchPriorityConfig;

    return (
      bConfig.fieldPriorityWeight - aConfig.fieldPriorityWeight ||
      bConfig.matchScore - aConfig.matchScore
    );
  }

  protected convertToAppInterface(
    item: SearchableAppInterface | SearchableCollectionInterface,
  ): AppInterface {
    return { ...item } as AppInterface;
  }

  protected convertToCollectionInterface(
    item: SearchableAppInterface | SearchableCollectionInterface,
  ): CollectionFinderItemDTO {
    return { ...item } as CollectionFinderItemDTO;
  }

  protected readonly ClickOnAppBehavior = ClickOnAppBehavior;
  protected readonly DisplayType = DisplayType;
}
